import { createContext } from 'react';

const CurrentDateContext = createContext({ today: new Date() });

export default CurrentDateContext;
